import { AlertTriangle } from "lucide-react";
import { CorpusCountText } from "@/features/data-curation/components/CorpusCountText";
import {
  formatCount,
  hasCorpusCount,
  ROW_LIMIT_CONTACT,
} from "@/features/data-curation/rowLimit";
import type { ExtractionCorpusEstimate } from "@/features/data-curation/types";

/** Shown above the grid when the curation has as many rows as it can have. */
export const CurationRowLimitBanner = ({
  rowLimit,
  totalRows,
  estimate,
}: {
  rowLimit?: number | null;
  totalRows: number;
  estimate?: ExtractionCorpusEstimate | null;
}) => {
  if (!rowLimit || totalRows < rowLimit) return null;
  return (
    <div
      role="status"
      className="flex gap-3 rounded-[3px] border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900"
    >
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" aria-hidden />
      <div className="space-y-1">
        <p className="font-medium">
          This dataset has reached its limit of {formatCount(rowLimit)} rows.
        </p>
        <p>
          {hasCorpusCount(estimate) && (
            <>
              <CorpusCountText estimate={estimate} />{" "}
            </>
          )}
          For more rows, contact{" "}
          <a
            href={`mailto:${ROW_LIMIT_CONTACT}`}
            className="font-medium underline underline-offset-2"
          >
            {ROW_LIMIT_CONTACT}
          </a>
          .
        </p>
      </div>
    </div>
  );
};
